// extracted by mini-css-extract-plugin
export var closeButton = "_cm-1";
export var closeX = "_cm-3";
export var container = "_cm-0";
export var image = "_cm-2";